<template>
  <div class="story2">

    <div class="c-header">
      <div class="c-header__bg">
        <img src="images/draw/bg/bg_stone.png" alt="">
      </div>
      <div class="c-header__logo">
        <img src="images/draw/common/header_logo.png" alt="">
      </div>
    </div>

    <div class="story2__talk-wrap">

      <div class="story2__talk story2__talk--1 js-fadein">
        <div class="story2__balloon">
          <img src="images/talk/balloon_6.png" alt="">
        </div>
        <div class="story2__icon">
          <img src="images/talk/icon_6.png" alt="">
        </div>
      </div>

      <div class="story2__talk story2__talk--2 js-fadein">
        <div class="story2__icon">
          <img src="images/talk/icon_7.png" alt="">
        </div>
        <div class="story2__balloon">
          <img src="images/talk/balloon_7.png" alt="">
        </div>
      </div>

      <div class="story2__talk story2__talk--3 js-fadein">
        <div class="story2__balloon">
          <img src="images/talk/balloon_8.png" alt="">
        </div>
        <div class="story2__icon">
          <img src="images/talk/icon_8.png" alt="">
        </div>
      </div>

      <div class="story2__talk story2__talk--4 js-fadein">
        <div class="story2__icon">
          <img src="images/talk/icon_9.png" alt="">
        </div>
        <div class="story2__balloon">
          <img src="images/talk/balloon_9.png" alt="">
        </div>
      </div>

      <div class="story2__talk story2__talk--5 js-fadein">
        <div class="story2__balloon">
          <img src="images/talk/balloon_10.png" alt="">
        </div>
        <div class="story2__icon">
          <img src="images/talk/icon_10.png" alt="">
        </div>
      </div>

    </div>
    
    <div class="story2__btn">
      <button v-on:click="toDraw" class="c-btn--pixel u-pixel10">→ イラストに挑戦する</button>
    </div>

    <button v-on:click="toTop" class="c-btn--top">
      <img src="images/draw/btn/btn_return_top.png" alt="離脱してTOPに戻る">
    </button>

    <footer class="c-footer">
      <div class="c-footer__img">
        <img src="images/top/copyright.png" alt="©米スタジオ・Boichi／集英社">
      </div>
    </footer>

    <div class="story2__bg" :style="[{width: width + 'px'}, {height: height + 'px'}, {'background-image':'url(images/draw/bg/bg_blue.jpg)' }]"></div>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default {
  components: {
  },
  data: function() {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
      st: null
    }
  },
  mounted() {
    gsap.set('.js-fadein', {autoAlpha:0, y: 20});

    this.st = ScrollTrigger.batch('.js-fadein', {
      onEnter: batch => gsap.to(batch, {autoAlpha: 1, y: 0,}),
      start: 'top 80%',
      scroller: '.contents',
      // markers: true,
    })

    window.addEventListener('resize', this.resize)
    this.resize()
  },
  beforeUnmount: function () {
    window.removeEventListener('resize', this.resize)
    this.st.forEach(item => {
      item.kill()
    });
  },
  methods: {
    toTop() {
      this.$emit("transition", "Top")
    },
    toDraw() {
      this.$emit("transition", "DrawStep2")
    },
    resize() {
      this.width = window.innerWidth;
      if(750 < this.width) {
        this.width = 390
      }
      this.height = window.innerHeight;
    }
  }
}

</script>

<style lang="scss">

.story2 {
  // overflow: scroll;
  position: relative;

  &__talk-wrap {
    padding-top: get_percent(calc_retina3(120px));
  }

  &__talk {
    align-items: center;
    display: flex;
    height: auto;
    justify-content: center;
    margin-bottom: get_percent(calc_retina3(120px));
    padding: 0 get_percent(calc_retina3(80px)) 0;
    width: 100%;
  }

  .story2__icon {
    width: get_percent(calc_retina3(200px), 336px);
  }

  &__talk--1 {
    .story2__balloon {
      width: get_percent(calc_retina3(717px), 336px);
    }
    .story2__icon {
      
    }
  }

  &__talk--2 {
    .story2__balloon {
      width: get_percent(calc_retina3(676px), 336px);
    }
    .story2__icon {
      
    }
  }

  &__talk--3 {
    .story2__balloon {
      width: get_percent(calc_retina3(686px), 336px);
    }
    .story2__icon {
      
    }
  }

  &__talk--4 {
    .story2__balloon {
      width: get_percent(calc_retina3(800px), 336px);
    }
    .story2__icon {
      
    }
  }

  &__talk--5 {
    .story2__balloon {
      width: get_percent(calc_retina3(760px), 336px);
    }
    .story2__icon {
      
    }
  }


  &__btn {
    margin: 0 auto get_percent(calc_retina3(120px));
  }

  &__bg {
    background-position-x: center;
    background-position-y: top;
    background-repeat: no-repeat;
    background-size: cover;
    left: 0;
    position: fixed;
    top: 0;
    z-index: -1;

    @include mq_pc {
      // inset: 0;
      left: 50%;
      transform: translateX(-50%);
      margin: 0 auto;
    }
  }
}

</style>
